module.exports = __webpack_public_path__ + "03c50bde4e00d0812580226ca4f46a6e.jpg";